function wordCount(text?: string | null): number {
  if (!text) return 0;
  return text.trim().split(" ").length;
}

export default wordCount;
